export const locale = {
  lang: 'en-CA',
  data: {
    CREATE_CLIENT: {
      TITLE: 'New client',
      TITLE_CONTACT: 'Infos contact client',
      TITLE_ADDRESS: 'Infos address client',
      COMM_LANGUAGE: 'Communication language',
    },
    CREATE_ENTERPRISE: {
      TITLE: 'New enterprise',
      TITLE_CONTACT: 'Company contact info',
      TITLE_ADDRESS: 'Company address info',
    },
    CREATE_CLIENT_ENTERPRISE: {
      PANEL_TITLE: 'New client & New enterprise',
      COPY_ENTERPRISE_TO_CLIENT: 'Copy company address to client',
      COPY_CLIENT_TO_ENTERPRISE: 'Copy client address to company',
    },
  },
};
